import React, { useState, useRef, useEffect } from "react";
import { DropdownWrapper } from "../../../../components/ui/dropdownwrapper/DropdownWrapper";
import Iconify from "../../../../layouts/components/iconify/iconify";
import "./TaskDetail.scss";
import RadioButton from "../../../../components/tasks/elementalUI/radiobutton/RadioButton";
import { AppIcons } from "../../../../data/appIcons";
import PrioritySelect from "../../../../components/ui/priorityDropdown/PrioritySelect";
import Input from "../../../../components/ui/inputs/input/Input";
import DropdownSelect from "../../../../components/finalForms/ui/inputs/dropdown/DropdownSelect";
import TaskTimeLog from "./feature/taskTimeLog/TaskTimeLog";
import { useLazyGetTaskByIdQuery, useUpdateTaskMutation, } from "../../../../app/services/taskAPI";
import { useGetProjectStatusWithPaginationMutation } from "../../../../app/services/projectStatusAPI";
import { useUpdateTeamTasksMutation } from "../../../../app/services/teamTaskAPI";
import { useLazyGetAllPriorityListQuery } from "../../../../app/services/priorityAPI";
import { useLazyGetAllTaskTypeListQuery } from "../../../../app/services/taskTypeAPI";
import { useGetPlanningListByUserIdAndProjectIdMutation } from "../../../../app/services/teamPlanningAPI";
import { useGetAllProjectTeamListMutation } from "../../../../app/services/projectTeamManagementAPI";
import ToastService from "../../../../services/toastService/ToastService";
import formatDate from "../../../../lib/formatDate";
import formatActualHours from "../../../../lib/formatActualHours";
import StatusSelect from "../../../../components/ui/statusDropdown/StatusSelect";
import { NumberValueType } from "../../../../data/formControlTypes";
import { useLazyGetProjectModuleByProjectIdQuery } from "../../../../app/services/projectModuleAPI";
import { useGetProjectComponentListMutation } from "../../../../app/services/projectComponentAPI";
import { useGetProjectVersionListMutation } from "../../../../app/services/projectVersionAPI";
import DatePicker from "../../../../components/ui/inputs/datePicker/DatePicker";
import AvatarSelect from "../../../../components/tasks/elementalUI/avatarselect/AvatarSelect";
import NewTaskAttachments from "./feature/attachments/NewTaskAttachments";
import NewTaskBug from "./feature/NewTaskBug/NewTaskBug";
import TaskDetailSkeleton from "./TaskDetailSkeleton";
import { useLazyGetAllSynergyByProjectIdQuery } from "../../../../app/services/projectSynergyAPI";
import CenterModel from "../../../../components/ui/centerModel/CenterModel";
import EditTaskDescription from "../../../task/taskDescription/EditTaskDescription";
import SidebarModal from "../../../../components/ui/sidebarModel/SidebarModel";
import DropDown from "../../../../components/finalForms/ui/inputs/dropdown/DropDown";

const taskPriorityData = [
  {
    value: "high",
    label: "High Priority",
    imagePath: AppIcons.High,
    color: "#E53935",
  },
  {
    value: "medium",
    label: "Medium Priority",
    imagePath: AppIcons.Medium,
    color: "#F69D0B",
  },
  {
    value: "low",
    label: "Low Priority",
    imagePath: AppIcons.Low,
    color: "#23C55E",
  },
];

const TaskDetail = ({ projectId, taskId, onSuccess }) => {

  const [copied, setCopied] = useState(false);
  const [title, setTitle] = useState("");
  const [taskTypesOptions, settaskTypesOptions] = useState([]);
  const [taskTypes, setTaskTypes] = useState({});
  const [isEditing] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const [selectpriorityId, setselectpriorityId] = useState(null);
  const [data, setData] = useState({});
  const [taskPriority, setTaskPriority] = useState(taskPriorityData);
  const [userList, setUserList] = useState([]);
  const titleRef = useRef(null);
  const [editEstTime, seteditEstTime] = useState("");
  const [isEditingTitle, setIsEditingTitle] = useState(false);
  const [editedTitle, setEditedTitle] = useState("");
  const [planningList, setplanningList] = useState([]);
  const [dueDate, setDueDate] = useState(null);
  const [planningId, setplanningId] = useState(null);
  const [reportedUser, setReportedUser] = useState([]);
  const [projectModule, setProjectModule] = useState([]);
  const [projectModuleId, setprojectModuleId] = useState(null);
  const [projectVersionId, setprojectVersionId] = useState();
  const [projectVersion, setProjectVersion] = useState([]);
  const [projectComponentId, setprojectComponentId] = useState(null);
  const [projectComponent, setProjectComponent] = useState([]);
  const [projectSynergyId, setprojectSynergyId] = useState(null);
  const [projectSynergy, setprojectSynergy] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [taskStatus, setTaskStatus] = useState([]);
  const [showCenterPopup, setShowCenterPopup] = useState(false);

  // API Calls
  const [getTaskById, {
    isFetching: isgetTaskByIdFetching,
    isSuccess: isgetTaskByIdFetched,
    data: getTaskByIdData,
  },] = useLazyGetTaskByIdQuery();

  const [getAllSynergyByProjectId, {
    isFetching: isAllSynergyFetching,
    isSuccess: isAllSynergySuccess,
    data: AllSynergyByProjectIdData,
  },] = useLazyGetAllSynergyByProjectIdQuery();

  const [getAllPriorityList, {
    isFetching: isPriorityFetching,
    isSuccess: isPrioritySuccess,
    data: isPriorityData,
  },] = useLazyGetAllPriorityListQuery();

  const [updateTask, {
    isLoading: updateTaskLoading,
    isSuccess: isSuccessUpdateTask,
    data: updateTaskTData,
  },] = useUpdateTaskMutation();

  const [getUserList, {
    isFetching: isUserNameFetching,
    isSuccess: isUserName,
    data: UserNameData,
  },] = useGetAllProjectTeamListMutation();

  const [getAllProjectComponentList, {
    isLoading: isProjectComponentListLoading,
    isSuccess: isProjectComponentListSuccess,
    data: isLProjectComponentListeData,
  },] = useGetProjectComponentListMutation();

  const [updateTeamTasks, {
    isLoading: updateTeamTasksLoading,
    isSuccess: isSuccessTeamTasks,
    data: updateTeamTasksData,
  },] = useUpdateTeamTasksMutation();

  const [getProjectModuleByProjectId, {
    isFetching: isgetProjectModuleByProjectIdfetching,
    isSuccess: isgetProjectModuleByProjectIdsuccess,
    data: isgetProjectModuleByProjectIdData,
  },] = useLazyGetProjectModuleByProjectIdQuery();

  const [getPlanningListByUserIdAndProjectId, {
    isFetching: isgetTeamPlanningListByUserIdfetching,
    isSuccess: isgetTeamPlanningListByUserIdsuccess,
    data: isgetTeamPlanningListByUserIdData,
  },] = useGetPlanningListByUserIdAndProjectIdMutation();

  const [getAllTaskTypeList, {
    isFetching: isTaskTypeFetching,
    isSuccess: isTaskTypeFetched,
    data: TaskTypeData,
  },] = useLazyGetAllTaskTypeListQuery();

  const [getAllProjectVersionList, {
    isLoading: isProjectVersionListLoading,
    isSuccess: isProjectVersionListSuccess,
    data: isLProjectVersionListeData,
  },] = useGetProjectVersionListMutation();

  const [getAllTaskStatus, {
    isFetching: isTaskStatusfetching,
    isSuccess: isTaskStatussuccess,
    data: isTaskStatusData,
  },] = useGetProjectStatusWithPaginationMutation();

  /** Every field edit saves and then refetches the task, so the skeleton is limited
   * to the first load and background saves get a lightweight indicator instead. */
  const hasLoadedTask = Boolean(data?.taskId);
  const isInitialTaskLoading = isgetTaskByIdFetching && !hasLoadedTask;
  const isSavingTask =
    updateTaskLoading ||
    updateTeamTasksLoading ||
    (isgetTaskByIdFetching && hasLoadedTask);

  const handleCopy = () => {

    let textToCopy = `${data?.projectCode}-${taskId} ${data?.title}`;

    navigator.clipboard.writeText(textToCopy);
    setCopied(true);
    ToastService.info("Task Detail Text Copied!");

    setTimeout(() => {
      setCopied(false);
    }, 800);
  };

  const closePopup = () => {
    setShowPopup(false);
  };

  const handleOpenPopup = () => {
    setShowPopup(true);
  };
  const closeCenterPopup = () => {
    setShowCenterPopup(false);
  };
  const handleOpenCenterPopup = () => {
    setShowCenterPopup(true);
  };

  const toggleDescription = () => {
    setIsExpanded((prevState) => !prevState);
  };

  const handleSuccess = () => {
    getTaskById(taskId);
    onSuccess?.();

  }

  useEffect(() => {
    getStatusListByProjectId();
    getAllTaskTypeList();
    getProjectComponentList();
    getProjectversiontList();
    getProjectModuleByProjectId(projectId);
    getAllSynergyByProjectId(projectId);
    getAllPriorityList();
    getUserListByProjectId();
    if (taskId) {
      getTaskById(taskId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getTaskById, taskId]);

  const handleEditTitle = () => {
    setEditedTitle(data.title || "");
    setIsEditingTitle(true);
  };

  const handleSaveTitle = () => {
    if (editedTitle && taskId) {
      setData((prev) => ({ ...prev, title: editedTitle }));
      setTitle(editedTitle);
      updateTask({ title: editedTitle, taskId });
      setIsEditingTitle(false);
    }
  };

  const handleCancelTitle = () => {
    setEditedTitle(data.title);
    setIsEditingTitle(false);
  };

  const handleEstTimeChange = (e) => {
    const numericValue = e.target.value;
    if (numericValue !== editEstTime) {
      seteditEstTime(numericValue);
    }
  };
  const handleSaveEstTime = () => {
    const estimateHours = editEstTime ? editEstTime : 0;
    if (
      editEstTime < 90 &&
      Number(estimateHours) !== Number(getTaskByIdData?.estimateHours ?? 0)
    ) {
      setData((prev) => ({ ...prev, estimateHours: estimateHours }));
      updateTask({
        estimateHours: estimateHours,
        taskId: taskId,
      });
    }
  };

  // const handleTitleChange = (e) => {
  //   const selection = window.getSelection();
  //   const range = selection.getRangeAt(0);
  //   const cursorPosition = range.startOffset; // Get cursor position before state update

  //   setTitle(e.target.innerText); // Update state without affecting cursor

  //   setTimeout(() => {
  //     if (titleRef.current) {
  //       const newRange = document.createRange();
  //       const selection = window.getSelection();
  //       newRange.setStart(titleRef.current.childNodes[0], cursorPosition);
  //       newRange.setEnd(titleRef.current.childNodes[0], cursorPosition);
  //       selection.removeAllRanges();
  //       selection.addRange(newRange);
  //     }
  //   }, 0); // Restore cursor after state update
  // };

  const getProjectversiontList = () => {
    const request = {
      pagination: {
        pageNumber: 1,
        pageSize: 40,
      },
      projectId: projectId,
    };
    getAllProjectVersionList(request);
  };

  const togglePopup = () => {
    setShowPopup(!showPopup);
  };

  const getStatusListByProjectId = () => {
    const request = {
      pagination: {
        pageNumber: 1,
        pageSize: 40,
      },
      projectId: projectId,
    };
    getAllTaskStatus(request);
  };

  const getUserListByProjectId = () => {
    const request = {
      pagination: {
        pageNumber: 1,
        pageSize: 40,
      },
      projectId: projectId,
    };
    getUserList(request);
  };

  const getProjectComponentList = () => {
    const request = {
      pagination: {
        pageNumber: 1,
        pageSize: 40,
      },
      projectId: projectId,
    };
    getAllProjectComponentList(request);
  };

  useEffect(() => {
    if (isEditing && titleRef.current) {
      titleRef.current.focus();

      // Move cursor to the end on edit start
      const selection = window.getSelection();
      const range = document.createRange();
      range.selectNodeContents(titleRef.current);
      range.collapse(false); // Move cursor to the end
      selection.removeAllRanges();
      selection.addRange(range);
    }
  }, [isEditing]); // Run only when entering edit mode

  useEffect(() => {
    if (isgetTaskByIdFetched && !isgetTaskByIdFetching && getTaskByIdData) {
      if (getTaskByIdData) {
        if (getTaskByIdData.assignedTo) {
          getPlanningListByUserIdAndProjectId({
            userId: getTaskByIdData.assignedTo,
            projectId: projectId,
          });
        }
        setData({
          ...getTaskByIdData,
          taskStatusId: getTaskByIdData.projectStatusConfigurationId,
          taskTypeId: getTaskByIdData.taskTypeId,
          priorityId: getTaskByIdData.priorityId,
          statusName: getTaskByIdData.statusName,
          taskTypeName: getTaskByIdData.taskTypeName,
          priorityName: getTaskByIdData.priorityName,
          planningID: getTaskByIdData.planningID,
          userName: getTaskByIdData.userName,
          planningName: getTaskByIdData.planningName,
          reportedName: getTaskByIdData.reportedName,
          assignedTo: getTaskByIdData.assignedTo,
          reportTo: getTaskByIdData.reportTo,
          projectName: getTaskByIdData.projectName,
          actualHours: getTaskByIdData.actualHours,
          badgeIcon:
            getTaskByIdData.taskTypeName === "Task"
              ? AppIcons.Task
              : getTaskByIdData.taskTypeName === "Bug"
                ? AppIcons.Bug
                : null,
        });

        setTaskTypes({
          value: getTaskByIdData.taskTypeId,
          label: getTaskByIdData.taskTypeName,
        });
        seteditEstTime(getTaskByIdData.estimateHours);
        setTitle(getTaskByIdData.title);
        setplanningId(getTaskByIdData.planningID);
        let deadline = getTaskByIdData.deadLine
          ? new Date(getTaskByIdData.deadLine)
          : new Date();
        setDueDate(deadline);
        if (getTaskByIdData.versionId) {
          setprojectVersionId(
            projectVersion.find(
              (option) => option.value === getTaskByIdData.versionId
            )
          );
        }
        if (getTaskByIdData.moduleId) {
          setprojectModuleId(
            projectModule.find(
              (option) => option.value === getTaskByIdData.moduleId
            )
          );
        }
        if (getTaskByIdData.componentId) {
          setprojectComponentId(
            projectComponent.find(
              (option) => option.value === getTaskByIdData.componentId
            )
          );
        }
        if (getTaskByIdData.synergyID) {
          setprojectSynergyId(
            projectSynergy.find(
              (option) => option.value === getTaskByIdData.synergyID
            )
          );
        }
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    isgetTaskByIdFetching,
    getTaskByIdData,
    isgetTaskByIdFetched,
    taskPriority,
    projectVersion,
    projectModule,
    projectComponent,
    projectSynergy,
  ]);

  useEffect(() => {
    if (
      isgetTeamPlanningListByUserIdsuccess &&
      !isgetTeamPlanningListByUserIdfetching &&
      isgetTeamPlanningListByUserIdData
    ) {
      const planningListData = isgetTeamPlanningListByUserIdData?.map(
        (item) => ({
          value: item.teamPlanningId,
          label: `${formatDate(item.startDate, "DD/MM/YYYY")} - ${formatDate(
            item.endDate,
            "DD/MM/YYYY"
          )} (${item.teamName})`,
        })
      );
      setplanningList(planningListData);
    }
  }, [
    isgetTeamPlanningListByUserIdsuccess,
    isgetTeamPlanningListByUserIdfetching,
    isgetTeamPlanningListByUserIdData,
  ]);

  useEffect(() => {
    if (!isTaskStatusfetching && isTaskStatussuccess && isTaskStatusData) {
      if (isTaskStatusData) {
        let status = isTaskStatusData.dataSource?.map((item) => ({
          value: item.projectStatusConfigurationId,
          label: item.statusName,
          isActive: item.isActive,
          isComplete: item.isComplete,
          statusCategoryId: item.statusCategoryId,
          statusCategoryName: item.statusCategoryName,
          className: item.statusCategoryName,
        }));
        status = status.filter((f) => f.isActive);
        setTaskStatus(status);
      }
    }
  }, [isTaskStatusfetching, isTaskStatussuccess, isTaskStatusData]);

  useEffect(() => {
    if (!isPriorityFetching && isPrioritySuccess && isPriorityData) {
      const priorityList = isPriorityData?.map((item) => ({
        value: item.priorityId,
        label: item.priorityName,
        imagePath:
          item.priorityName === "High"
            ? AppIcons.High
            : item.priorityName === "Medium"
              ? AppIcons.Medium
              : item.priorityName === "Low"
                ? AppIcons.Low
                : null,
      }));
      setTaskPriority(priorityList);
    }
  }, [isPriorityFetching, isPrioritySuccess, isPriorityData]);

  useEffect(() => {
    if (data?.priorityId && taskPriority.length > 0) {
      const selectedPriority = taskPriority.find(
        (task) => task.value === data.priorityId
      );
      setselectpriorityId(selectedPriority);
    }
  }, [data?.priorityId, taskPriority]);

  useEffect(() => {
    if (isUserName && !isUserNameFetching && UserNameData) {
      const userNameList = UserNameData.dataSource?.map((item) => ({
        value: item.userId,
        label: item.userName,
      }));
      setUserList(userNameList);
    }
  }, [isUserName, isUserNameFetching, UserNameData]);

  useEffect(() => {
    if (
      !isAllSynergyFetching &&
      isAllSynergySuccess &&
      AllSynergyByProjectIdData
    ) {
      const projectData = AllSynergyByProjectIdData?.map((item) => ({
        value: item.synergyId,
        label: item.title,
      }));
      setprojectSynergy(projectData);
    }
  }, [isAllSynergyFetching, isAllSynergySuccess, AllSynergyByProjectIdData]);

  useEffect(() => {
    if (
      !isProjectComponentListLoading &&
      isProjectComponentListSuccess &&
      isLProjectComponentListeData
    ) {
      const projectComponentListData =
        isLProjectComponentListeData.dataSource?.map((item) => ({
          value: item.projectComponentId,
          label: item.projectComponent,
        }));
      setProjectComponent(projectComponentListData);
    }
  }, [
    isProjectComponentListLoading,
    isProjectComponentListSuccess,
    isLProjectComponentListeData,
  ]);

  useEffect(() => {
    if (isUserName && !isUserNameFetching && UserNameData) {
      const userNameList = UserNameData.dataSource?.map((item) => ({
        value: item.userId,
        label: item.userName,
      }));
      setReportedUser(userNameList);
    }
  }, [isUserName, isUserNameFetching, UserNameData]);

  useEffect(() => {
    if (
      !isgetProjectModuleByProjectIdfetching &&
      isgetProjectModuleByProjectIdsuccess &&
      isgetProjectModuleByProjectIdData
    ) {
      const projectModuleListData = isgetProjectModuleByProjectIdData?.map(
        (item) => ({
          value: item.projectModuleId,
          label: item.projectModule,
        })
      );
      setProjectModule(projectModuleListData);
    }
  }, [
    isgetProjectModuleByProjectIdfetching,
    isgetProjectModuleByProjectIdsuccess,
    isgetProjectModuleByProjectIdData,
  ]);

  useEffect(() => {
    if (!isTaskTypeFetching && isTaskTypeFetched && TaskTypeData) {
      const badgeOptions = TaskTypeData?.map((item) => ({
        value: item.taskTypeId,
        label: item.taskTypeName,
      }));
      settaskTypesOptions(badgeOptions);
    }
  }, [isTaskTypeFetching, isTaskTypeFetched, TaskTypeData]);

  useEffect(() => {
    if (
      !isProjectVersionListLoading &&
      isProjectVersionListSuccess &&
      isLProjectVersionListeData
    ) {
      const projectVersionListData = isLProjectVersionListeData.dataSource?.map(
        (item) => ({
          value: item.projectVersionId,
          label: item.projectVersion,
          isRelease: item.isRelease,
        })
      );
      const filterdata = projectVersionListData.filter((f) => f.isRelease);
      setProjectVersion(filterdata);
    }
  }, [
    isProjectVersionListLoading,
    isProjectVersionListSuccess,
    isLProjectVersionListeData,
  ]);

  const handleSelectionChange = (newSelectedOptions) => {
    if (newSelectedOptions && newSelectedOptions[0]) {
      setData((prev) => ({
        ...prev,
        assignedTo: newSelectedOptions[0].value,
        userName: newSelectedOptions[0].label,
      }));
      updateTask({ assignedTo: newSelectedOptions[0].value, taskId: taskId });
    }
  };

  const handleSelectionChangereported = (newSelectedOptions) => {
    if (newSelectedOptions && newSelectedOptions[0]) {
      setData((prev) => ({
        ...prev,
        reportTo: newSelectedOptions[0].value,
        reportedName: newSelectedOptions[0].label,
      }));
      updateTask({ reportTo: newSelectedOptions[0].value, taskId: taskId });
    }
  };

  const handleSaveDescription = (updatedDescription) => {
    setData((prev) => ({ ...prev, description: updatedDescription }));
    updateTask({ description: updatedDescription, taskId: data.taskId });
  };

  const handalselectstatus = (newSelectedOptions, taskId) => {
    if (newSelectedOptions) {
      setData((prev) => ({
        ...prev,
        projectStatusConfigurationId: newSelectedOptions.value,
        taskStatusId: newSelectedOptions.value,
        statusName: newSelectedOptions.label,
      }));
      updateTask({
        taskStatusId: newSelectedOptions.value,
        taskId: taskId,
      });
    }
  };

  const handleTaskTypeChange = (newType) => {
    const selectedType = taskTypesOptions.find(
      (option) => option.value === newType.value
    );
    setTaskTypes(selectedType);
    setData((prev) => ({
      ...prev,
      taskTypeId: selectedType.value,
      taskTypeName: selectedType.label,
      badgeIcon:
        selectedType.label === "Task"
          ? AppIcons.Task
          : selectedType.label === "Bug"
            ? AppIcons.Bug
            : null,
    }));
    updateTask({ taskTypeId: selectedType.value, taskId: taskId });
  };

  const handalselectPriority = (newSelectedOptions, taskId) => {
    if (newSelectedOptions) {
      setselectpriorityId(newSelectedOptions);
      setData((prev) => ({
        ...prev,
        priorityId: newSelectedOptions.value,
        priorityName: newSelectedOptions.label,
        imagePath: newSelectedOptions.imagePath,
      }));
      updateTask({
        priorityId: newSelectedOptions.value,
        taskId: taskId,
      });
    }
  };

  useEffect(() => {
    if (isSuccessTeamTasks && updateTeamTasksData) {
      if (updateTeamTasksData.errorMessage.includes("exists")) {
        ToastService.warning(updateTeamTasksData.errorMessage);
        return;
      } else {
        ToastService.success(updateTeamTasksData.errorMessage);
        if (taskId) {
          getTaskById(taskId);
        }
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccessTeamTasks, updateTeamTasksData]);

  const handalchangeDate = (value) => {
    setDueDate(value);
    if (value) {
      setData((prev) => ({ ...prev, deadLine: value }));
      updateTask({
        deadLine: value,
        taskId: taskId,
      });
    }
  };

  useEffect(() => {
    if (isSuccessUpdateTask && updateTaskTData) {
      if (updateTaskTData.errorMessage) {
        if (updateTaskTData.errorMessage.includes("exists")) {
          ToastService.warning(updateTaskTData.errorMessage);
          return;
        } else {
          ToastService.success(updateTaskTData.errorMessage);
          onSuccess?.();
          if (taskId) {
            getTaskById(taskId);
          }
          closePopup();
        }
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccessUpdateTask, updateTaskTData]);

  if (isInitialTaskLoading) {
    return <TaskDetailSkeleton />;
  } else {
    return (
      <>
        <div className="edit-mytask-section-title">
          <div className="section-title">
            <div className="taskdetail-type">
              <DropdownWrapper
                toggleElement={
                  <div className="tasktype-dropdown">
                    <div className="tasktype-icon">
                      <RadioButton
                        defaultChecked
                        color={taskTypes.label === "Task" ? "primary" : "error"}
                      />
                    </div>
                    <div className="tasktype-title">{taskTypes.label}</div>
                    <Iconify icon="iconamoon:arrow-down-2" />
                  </div>
                }
                closeOnSelect
              >
                <div className="task-grid-tasktype-dropdown-container">
                  {taskTypesOptions?.map((option) => (
                    <button
                      key={option.value}
                      onClick={() =>
                        handleTaskTypeChange({
                          value: option.value,
                          label: option.label,
                        })
                      }
                    >
                      <RadioButton
                        defaultChecked
                        checked={taskTypes.value === option.value}
                        color={option.label === "Task" ? "primary" : "error"}
                        size="14px"
                      />
                      <div className="tasktype-label">{option.label}</div>
                    </button>
                  ))}
                </div>
              </DropdownWrapper>
            </div>
            {isEditingTitle ? (
              <div className="editable-title">
                <input
                  type="text"
                  value={editedTitle}
                  onChange={(e) => setEditedTitle(e.target.value)}
                  className="title-input d-flex "
                  max={50}
                />

                <div className="edit-buttons">
                  <button className="save-btn" onClick={handleSaveTitle}>
                    <Iconify icon="material-symbols:check" />
                  </button>
                  <button className="cancel-btn" onClick={handleCancelTitle}>
                    <Iconify icon="material-symbols:close" />
                  </button>
                </div>
              </div>
            ) : (
              <span className="task-main-title" onClick={handleEditTitle}>{data.title}</span>
            )}
            {isSavingTask && (
              <div className="task-saving-indicator">
                <Iconify icon="line-md:loading-twotone-loop" />
                <span>Saving...</span>
              </div>
            )}
          </div>
        </div>
        <div className="edit-mytask-section-description">
          <div className="taskdetail-section">
            <div className="taskdetail-header">
              <div className="taskdetail-header-left-section">
                <button className="taskdetail-id task" onClick={handleCopy}>
                  {!copied ? (
                    <>
                      {data?.projectCode + "-" + taskId || 0}
                      <Iconify icon="iconamoon:copy-light" />
                    </>
                  ) : (
                    <span className="copied-text">Copied!</span>
                  )}
                </button>
                <div className="taskdetail-projectname">
                  {data.projectName}
                </div>
              </div>
              <div className="additional-detail-item additional-todo-up">
                <div className="additional-detail-label additional-todo-label">
                  <Iconify icon="f7:status" />
                  Status
                </div>
                <div className="additional-detail-value additional-todo-value">
                  <StatusSelect
                    options={taskStatus}
                    initstate={
                      taskStatus.find(
                        (s) => s.value === data.projectStatusConfigurationId
                      ) || {
                        value: data.projectStatusConfigurationId,
                        label: data.statusName,
                      }
                    }
                    id={data.taskId}
                    onSelectionChange={handalselectstatus}
                  />
                </div>
              </div>
            </div>

            {/* Backlog Badge End */}

            <div className="taskdetail-additional-details">
              <div className="detail-row">
                <div className="additional-detail-item">
                  <div className="additional-detail-label">
                    <Iconify icon="healthicons:ui-user-profile" />
                    Assignee
                  </div>
                  <div className="additional-detail-value">
                    <AvatarSelect
                      initState={{
                        value: data?.assignedTo,
                        label: data?.userName,
                      }}
                      onSelectionChange={handleSelectionChange}
                      options={userList}
                      selectMode="single"
                      id="task-avatar-dropdown"
                    />
                  </div>
                </div>
                <div className="additional-detail-item">
                  <div className="additional-detail-label">
                    <Iconify icon="healthicons:ui-user-profile" />
                    Reported User
                  </div>
                  <div className="additional-detail-value">
                    <AvatarSelect
                      initState={{
                        value: data?.reportTo,
                        label: data?.reportedName,
                      }}
                      onSelectionChange={handleSelectionChangereported}
                      options={reportedUser}
                      selectMode="single"
                    />
                  </div>
                </div>
              </div>

              <div className="detail-row">
                <div className="additional-detail-item">
                  <div className="additional-detail-label">
                    <Iconify icon="lets-icons:date-today-duotone-line" />
                    Due Date
                  </div>
                  <div className="additional-detail-value">
                    <DatePicker
                      selected={dueDate}
                      onChange={handalchangeDate}
                      autoComplete="off"
                      disabled={false}
                      placeholder={"Due Date"}
                      datePickerConfig={{ dateFormat: "dd/MM/yyyy" }}
                    />
                  </div>
                </div>
                <div className="additional-detail-item">
                  <div className="additional-detail-label">
                    <Iconify icon="lets-icons:date-today-duotone-line" />
                    Created Date
                  </div>
                  <div className="additional-detail-value readonly-value">
                    {formatDate(
                      getTaskByIdData ? getTaskByIdData.createdAt : "",
                      "DD/MM/YYYY hh:mm A"
                    )}
                  </div>
                </div>
              </div>

              <div className="detail-row">
                <div className="additional-detail-item">
                  <div className="additional-detail-label">
                    <Iconify icon="mynaui:clock-four" />
                    Estimate Hours
                  </div>
                  <div className="additional-detail-value">
                    <Input
                      type="number"
                      className="edit-input"
                      value={editEstTime}
                      valueType={NumberValueType.DECIMAL}
                      onBlur={(e) => handleSaveEstTime(e)}
                      onChange={(e) => {
                        const value = parseFloat(e.target.value);
                        if (isNaN(value)) {
                          handleEstTimeChange(e);
                        } else if (value >= 0 && value <= 90) {
                          handleEstTimeChange(e);
                        }
                      }}
                      min={0}
                      max={90}
                      step={0.1}
                    />
                  </div>
                </div>
                <div className="additional-detail-item actual-hrs">
                  <div className="additional-detail-label">
                    <Iconify icon="hugeicons:clock-04" />
                    Actual Hours
                  </div>
                  <div className="additional-detail-value readonly-value with-action">
                    <span>{formatActualHours(data.actualHours)}</span>
                    <DropdownWrapper
                      direction="left"
                      toggleElement={
                        <button type="button" className="actual-hrs-btn" title="Add time log">
                          <Iconify icon="zondicons:add-outline" width={16} />
                        </button>
                      }
                    >
                      <div>
                        <TaskTimeLog
                          taskId={taskId}
                          projectId={projectId}
                          isEdit={false}
                          editData={null}
                          onSuccess={handleSuccess}
                        />
                      </div>
                    </DropdownWrapper>
                  </div>
                </div>
              </div>

              <div className="detail-row">
                <div className="additional-detail-item">
                  <div className="additional-detail-label">
                    <Iconify icon="iconamoon:flag-light" />
                    Priority
                  </div>
                  <div className="additional-detail-value">
                    <PrioritySelect
                      options={taskPriority}
                      initstate={selectpriorityId}
                      id={data.taskId}
                      onSelectionChange={handalselectPriority}
                    />
                  </div>
                </div>
                <div className="additional-detail-item">
                  <div className="additional-detail-label">
                    <Iconify icon="si:dashboard-vert-line" />
                    Planning
                  </div>
                  <div className="additional-detail-value">
                    <DropDown
                      title="Planning"
                      type="dropdown"
                      options={planningList}
                      value={planningId || data.planningID}
                      placeholder="Select Planning"
                      classNamePrefix="report-user-type"
                      isSearchable={false}
                      onChange={(selectedOption) => {
                        setplanningId(selectedOption);
                        setData((prev) => ({
                          ...prev,
                          planningID: selectedOption.value,
                          planningName: selectedOption.label,
                        }));
                        updateTeamTasks({
                          planningId: selectedOption.value,
                          taskId: taskId,
                          projectId: projectId,
                        });
                      }}
                    />
                  </div>
                </div>
              </div>

              <div className="detail-row">
                <div className="additional-detail-item">
                  <div className="additional-detail-label">
                    <Iconify icon="famicons:cube-outline" />
                    Module
                  </div>
                  <div className="additional-detail-value">
                    <DropdownSelect
                      optionsValue={projectModule}
                      value={projectModuleId}
                      handleDropdownChange={(selectedOption) => {
                        setprojectModuleId(selectedOption);
                        updateTask({
                          moduleId: selectedOption.value,
                          taskId: taskId,
                        });
                      }}
                      placeholder={"Select Module"}
                    />
                  </div>
                </div>
                <div className="additional-detail-item">
                  <div className="additional-detail-label">
                    <Iconify icon="lucide:component" />
                    Component
                  </div>
                  <div className="additional-detail-value">
                    <DropdownSelect
                      optionsValue={projectComponent}
                      value={projectComponentId}
                      handleDropdownChange={(selectedOption) => {
                        setprojectComponentId(selectedOption);
                        updateTask({
                          componentId: selectedOption.value,
                          taskId: taskId,
                        });
                      }}
                      placeholder={"Select Component"}
                    />
                  </div>
                </div>
              </div>

              <div className="detail-row">
                <div className="additional-detail-item">
                  <div className="additional-detail-label">
                    <Iconify icon="system-uicons:versions" />
                    Version
                  </div>
                  <div className="additional-detail-value">
                    <DropdownSelect
                      optionsValue={projectVersion}
                      value={projectVersionId}
                      handleDropdownChange={(selectedOption) => {
                        setprojectVersionId(selectedOption);
                        updateTask({
                          versionId: selectedOption.value,
                          taskId: taskId,
                        });
                      }}
                      placeholder={"Select Version"}
                    />
                  </div>
                </div>
                <div className="additional-detail-item">
                  <div className="additional-detail-label">
                    <Iconify icon="famicons:sync-circle-outline" />
                    Synergy
                  </div>
                  <div className="additional-detail-value">
                    <DropdownSelect
                      optionsValue={projectSynergy}
                      value={projectSynergyId}
                      handleDropdownChange={(selectedOption) => {
                        setprojectSynergyId(selectedOption);
                        updateTask({
                          synergyID: selectedOption.value,
                          taskId: taskId,
                        });
                      }}
                      placeholder={"Select Synergy"}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="taskdetail-desription">
              <div className="taskdetail-description-label">
                Task Description:
              </div>
              <div className="taskdetail-description-content">
                <div
                  className={`taskdetail-description-contentbox ${isExpanded ? "expanded" : ""
                    }`}
                >
                  <div className="edit-taskdescription-icon">
                    <button
                      type="submit"
                      className="btn edit-btn view"
                      onClick={handleOpenCenterPopup}
                    >
                      <Iconify icon="mdi:eye" />
                    </button>
                    <button
                      type="submit"
                      className="btn edit-btn"
                      onClick={handleOpenPopup}
                    >
                      <Iconify icon="line-md:pencil" />
                    </button>
                  </div>

                  <div
                    className="image-container"
                    dangerouslySetInnerHTML={{ __html: data.description }}
                  ></div>
                </div>
                <button
                  className="taskdetail-readmore-btn"
                  onClick={toggleDescription}
                >
                  {isExpanded ? "Read Less" : "Read More"}
                </button>
              </div>
            </div>

            <div className="taskdetail-attachments">
              <NewTaskAttachments taskId={taskId} projectId={projectId} />
            </div>
            {/* <div className="referencetask-sec">
              <NewReferenceTask taskId={taskId} projectId={projectId} />
            </div> */}

            {/* <div className="new-timelog">
              <NewTimeLog taskId={taskId} />
            </div> */}
            <div className="new-taskbug">
              <NewTaskBug taskId={taskId} projectId={projectId} />
            </div>

            <SidebarModal
              isOpen={showPopup}
              onClose={closePopup}
              modalTitle="Edit Task Description"
              modalSize="w-45"
              defaultPosition="left"
              className={"edit-task-ck"}
            >
              {showPopup && (
                <EditTaskDescription
                  taskId={data.taskId}
                  description={data.description}
                  updateTask={handleSaveDescription}
                  togglePopup={togglePopup}
                />
              )}
            </SidebarModal>

            <CenterModel
              showModal={showCenterPopup}
              className="view-description-center-modal"
              handleToggleModal={closeCenterPopup}
              modalTitle={`View Description`}
              modelSizeClass="w-85"
            >
              <div dangerouslySetInnerHTML={{ __html: data.description }}></div>
            </CenterModel>
          </div>
        </div>
      </>
    );
  }
};

export default TaskDetail;
